import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { useAppStore } from '@/stores/appStore'
import router from '@/config/routes'

import '@/assets/main.css'
import App from '@/App.vue'

import { createHead } from '@unhead/vue/client'

import vueClickOutsideElement from 'vue-click-outside-element'

import CookieConsentVue from '@/plugins/CookieConsentVue'
import VueGtag, { trackRouter } from 'vue-gtag-next'

/**
 * FontAwesome core
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * FontAwesome icons
 */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

/**
 * Application creation
 */
const app = createApp(App)

app.component('FontAwesomeIcon', FontAwesomeIcon)

app.use(router)
app.use(createPinia())
app.use(createHead())
app.use(CookieConsentVue)
app.use(VueGtag)
app.use(vueClickOutsideElement)

trackRouter(router)

router.isReady().then(() => {
	app.mount('#app')
})

// Initialize and apply theme
const appStore = useAppStore()
appStore.initTheme()
